<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import "node-hub-article-v2"
</style>

<script>
    import Grid     from '../../common/components/Grid.vue'
    import GridItem from '../../common/components/GridItem.vue'
    import Newsfeed from '../../common/components/Newsfeed.vue'
    import { onMounted, nextTick } from "vue";
    import { Navigation } from 'swiper/modules';

    export default {
        components: {
            Grid,
            GridItem,
            Newsfeed
        },
        setup(){
          onMounted(async () => {
            await nextTick();
            const windowPath = window.location.pathname;

            const updatedPath = windowPath
              .replace(/[+"?!/]/g, '') // Fixed regex for forward slash
              .replace(/[#_', ]/g, '_')
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");

            const itemToPush = {
              pagetype: "hub_article_v2",
              pagename: updatedPath,
              event: "page_load",
            };

            // Push to the global dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(itemToPush);

          return {
            Grid, GridItem, Newsfeed,
            modules: [Navigation],
          }
          });
        }
    }
</script>
